"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 15 15';

var PointerRight = function PointerRight() {
  return _react["default"].createElement("g", {
    transform: "translate(0.5, 0.8)"
  }, _react["default"].createElement("path", {
    transform: "translate(0.4, 0.2)",
    d: "M13.24029,7.65058 C13.06459,7.65058 12.88889,7.58268 12.75519,7.44898 L6.47829,1.17208 C6.21019,0.90398 6.21019,0.46928 6.47829,0.20118 C6.74639,-0.06692 7.18109,-0.06692 7.44919,0.20118 L13.72609,6.47808 C13.99419,6.74618 13.99419,7.18088 13.72609,7.44898 C13.59169,7.58268 13.41599,7.65058 13.24029,7.65058"
  }), _react["default"].createElement("path", {
    transform: "translate(0, 6.5)",
    d: "M12.09943,1.42331 L0.68663,1.42331 C0.30723,1.42331 -7e-05,1.11601 -7e-05,0.73661 C-7e-05,0.35721 0.30723,0.04991 0.68663,0.04991 L12.09943,0.04991 C12.47883,0.04991 12.78543,0.35721 12.78543,0.73661 C12.78543,1.11601 12.47883,1.42331 12.09943,1.42331"
  }), _react["default"].createElement("path", {
    transform: "translate(6, 6.5)",
    d: "M1.36353,7.70007 C1.18783,7.70007 1.01213,7.63287 0.87843,7.49917 C0.61033,7.23037 0.61033,6.79637 0.87843,6.52757 L7.15463,0.25067 C7.42343,-0.01673 7.85743,-0.01673 8.12623,0.25067 C8.39433,0.51877 8.39433,0.95347 8.12623,1.22157 L1.84863,7.49917 C1.71493,7.63287 1.53923,7.70007 1.36353,7.70007"
  }));
};

var _default = (0, _createSvgIcon["default"])(PointerRight, {
  viewBox: viewBox
});

exports["default"] = _default;